import React, { createRef } from "react";
import useStyles from "./styles";
import CloseIcon from "@material-ui/icons/Close";

import { Grid, Dialog, IconButton } from "@material-ui/core";
import { Images } from "config/images";

const DialogFeedBack = props => {
	const classes = useStyles();
	const { handleClose, open, handleConfirm } = props;
	const nodeRef = createRef();

	return (
		<Dialog
			onClose={() => handleClose()}
			aria-labelledby="customized-dialog-title"
			open={open}
			ref={nodeRef}
			fullWidth
		>
			<Grid>
				<Grid classes={{ root: classes.closeButton }}>
					<IconButton
						aria-label="close"
						onClick={() => handleClose()}
					>
						<CloseIcon />
					</IconButton>
				</Grid>
				<Grid classes={{ root: classes.body }}>
					<img
						src={Images.icGiftSuccess}
						alt={"icGiftSuccess"}
						width={72}
					/>
					<Grid classes={{ root: classes.title }}>
						Cảm ơn bạn đã liên hệ cho chúng tôi
					</Grid>
					<Grid classes={{ root: classes.driver }} />
					<Grid
						classes={{ root: classes.btnSubmit }}
						onClick={() => handleConfirm()}
					>
						Xác nhận
					</Grid>
				</Grid>
			</Grid>
		</Dialog>
	);
};

export default DialogFeedBack;
